import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'ui-common-components/design-system/tokens.css';
import 'ui-common-components/index.css';
import App from '@/App';
import AppErrorBoundary from '@/components/AppErrorBoundary';
import '@/index.css';
import { reloadOnceForChunkError } from '@/utils/chunkReload';

// Vite fires this when a lazy route's chunk (or its CSS) cannot be fetched —
// almost always a tab left open across a deploy. Reload to pick up the new
// build instead of showing the error screen.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnceForChunkError()) event.preventDefault();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {/* Outside the router, so a throw during routing is caught too. Without
        this, any render-time exception unmounts the whole tree and the user
        gets a blank white page with no message. */}
    <AppErrorBoundary>
      {/* Both v7 behaviours are opted into now rather than at the upgrade.
          React Router logs a "Future Flag Warning" for each one until you do,
          and — unlike a normal dev-only warning — that log survives into the
          production bundle, so it greeted anyone who opened the console.

          v7_relativeSplatPath changes how relative paths resolve INSIDE a splat
          route. This app has exactly one (`path="*"`), and it renders
          <Navigate to="/"> — an absolute path — so the new rule cannot change
          where anything goes.

          v7_startTransition wraps router state updates in React.startTransition.
          That is what the lazily-loaded routes here already want: navigation
          stays interactive instead of blocking on a route's chunk. */}
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </AppErrorBoundary>
  </React.StrictMode>,
);
